/**
 * Created by Languagenut on 18/04/2019.
 */


import React  from 'react';
import {Card, Row , Col, Alert} from 'react-bootstrap'
import 'react-multiselect-box/build/css/index.css'
import Translation from '../../../store/internationalization-store.js'
import {ProductService , AccountService} from '../../../services';
import {ProductStore , AccountStore} from '../../../store';
import Constants from '../../../constants.js';
import Popup from '../../popup/comfirmation_popup.js'
import Select from  'react-select';
import LanguageSelect from '../../language_select.js';
import Checkbox from '../../checkbox.js';

class ClassLanguageSettings extends React.Component {

    constructor(props) {
        super();
        this.props = props;

        var l = ProductStore.getLearningLanguages();
        var list = [];

        for(var i = 0 ; i < l.length; i++) {
            list.push({value:String(l[i].ietf) , label:Translation.get(l[i].name , l[i].name)})
        }

        this.state = {
            languageOptions:list,
            selectedItems: [],
            totalCurriculumOptions:[]
        };

        this.props.data.allLanguages = true;
        this.props.data.selectedlanguages = [];
    }


    componentWillMount(){
        ProductStore.on(Constants.GET_ADDITIONAL_CURRICULUM,  ()=>{
            var additionalCurriculums = ProductStore.getAdditionalCurriculums();
            
            var list = [];
            var selectedList = [];
            for(var i = 0 ; i < additionalCurriculums.length; i++) {
                list.push({value:String(additionalCurriculums[i].curriculumUid),
                    label:additionalCurriculums[i].name, 
                    ietf:additionalCurriculums[i].ietf, 
                    languageTitle:additionalCurriculums[i].languageName, 
                    isSelected:additionalCurriculums[i].isSelected == true,
                    information:additionalCurriculums[i].information})
            }

            this.setState({
                totalCurriculumOptions:list
            })

        });

        ProductStore.on(Constants.GET_LANGUAGES ,  ()=>{
                var l = ProductStore.getLearningLanguages();
                var list = [];
                for(var i = 0 ; i < l.length; i++)
                {
                    list.push({value:String(l[i].ietf) , label:Translation.get(l[i].name , l[i].name)})
                }
                this.setState({
                    languageOptions:list
                })

        });

        AccountStore.on(Constants.GET_ACCOUNT_STAFF , ()=>{
            var l = AccountStore.staff;
            var list = [];

            for(var i = 0 ; i < l.length; i++) {
                console.log(l[i])
                list.push({value:String(l[i].uid) , label:l[i].name})
            }

            this.setState({
                staffOptions:list || [],
            })
        })
    }

    componentDidMount(){
        ProductService.getAllLanguages();
        AccountService.getMembers()
    }

    onChangeLanguages(languages){
        if(languages == undefined || languages == null) {
            this.props.data.selectedlanguages = [];
            return;
        }

        this.props.data.allLanguages = false
        var l = [];

        for(var i = 0 ; i < languages.length; i++) {
            l.push(languages[i].value)
        }

        this.props.data.selectedlanguages = l;

        this.setState({filterClassLanguages:languages,
                    update:true});
    }

    onChangeStaff(staff) {
        this.props.data.sharedTeachers = staff;
    }

    onChangeCurriculums(curriculums){
        this.props.data.curriculumOptions =curriculums;
    }

    generateSelectableOptions() {
        var languagesData = [];
        var data = this.state.totalCurriculumOptions;
        for (var i = 0; i < data.length; i++) {
            if (languagesData[data[i].ietf] == undefined) {
                languagesData[data[i].ietf] = [data[i].languageTitle, [<hr></hr>]]
            }
            languagesData[data[i].ietf][1].push(this.getVocabList(data[i], languagesData[data[i].ietf][1].length == 1))
        }
        return languagesData;
    }

    getVocabList(data, isFirst) {
        var firstStyle = "0px 1px 1px 1px"
        if (isFirst) {
            firstStyle = "1px 1px 1px 1px"
        }
        return  <div style={{border:"rgb(0, 0, 0)", borderWidth:firstStyle, 
                borderStyle:"solid", padding:"10px"}}>
            <Row > 
                <Col sm={{span: 10, offset: 0}}><Card.Text><i onClick={()=>{
                        this.setState({information:true, infoData:data.information})}
                        } class="fas fa-info-circle"></i>
                    <span onClick={function() {
                            data.isSelected = !data.isSelected
                            this.setState({updated:true})
                        }.bind(this)}>{data.label}</span>
                </Card.Text></Col>
                <Col sm={{span: 2, offset: 0}}><span className="float-right" onClick={function() {
                        data.isSelected = !data.isSelected
                        this.setState({updated:true})
                    }.bind(this)}>
                        <Checkbox isDisabled checked={data.isSelected}/></span>
                </Col>
            </Row>
        </div>
    }

    setLanguageValue(language){
        this.language = language.ietf;
        this.setState({updated:true})
    }

    render(){
        var curriculumData = "";
        var generateOptions = this.generateSelectableOptions();
        var finalData = ""
        if (generateOptions[this.language] != undefined) {
            finalData = generateOptions[this.language][1];
        }

        if (this.state.totalCurriculumOptions.length > 0) {
            curriculumData = [popup,
            <Row>
                <Col md={12}>
                    <Alert variant="success">
                        {Translation.get(12731 , 'This content has been created by the Languagenut Teacher community and validated by the Languagenut team')}
                    </Alert>
                </Col>
            </Row>,
            <Row>
                <Col md={4}><LanguageSelect limitLanguages={this.state.filterClassLanguages} returnValue={this.setLanguageValue.bind(this)} title={<b>{Translation.get(12684, 'Select a language')}</b>}/></Col>
            </Row>,
            <Row>
                <Col md={12}>
                    {finalData}
                </Col>
            </Row>]
        }

        var popup = <Popup title={"Additional Vocab Information"} oneButton={true} onSave={()=>{ this.setState({information:false});}} 
                onHide={()=>{this.setState({information:false})}} show={this.state.information} 
                body={this.state.infoData} />

        return <div style={{padding:"20px"}}>
            {popup}
            <Row>
                <Col md={12}>
                   <span>
                 <lable>{Translation.get(2440 ,'Select Languages')}</lable>
                    <Select placeholder={Translation.get(12732 , 'All languages')} isMulti={true} onChange={this.onChangeLanguages.bind(this)} name="form-field-name" value={this.state.language} options={this.state.languageOptions}/>
            </span>
                </Col>
            </Row>
            <br/>
            <Row>
                <Col md={12}>
                    <lable>{Translation.get(2441 ,'Select Additional Teachers')}</lable>
                    <Select  placeholder={Translation.get(595 , 'Search')} isMulti={true} onChange={this.onChangeStaff.bind(this)} name="form-field-name" value={this.state.staff} options={this.state.staffOptions}/>
                </Col>
            </Row>
            <br/>
            {curriculumData}
        </div>
    }
}

export default {
    name: function() {return Translation.get(906 , 'Settings')},
    icon:<i class="fa-2x fas fa-cog"></i>,
    title:null,
    onSubmit: function (done){
        done();
    },
    onBack:function(done){
        done();
    },
    component: ClassLanguageSettings
}